import ProjectService from 'v1/global/services/project';
import defaultConfig from './config';

class IssueLoiService extends ProjectService {
  constructor(initialValues = {}, config = defaultConfig) {
    super(config);

    const { templates, callback } = initialValues;
    const options = templates
      // .filter((t) => t?.s3_key?.toLowerCase().includes('mclaren'))
      .map((template) => {
        const { name, id } = template;
        return {
          id,
          value: id,
          label: name,
        };
      });
    const [newFormField] = [...this.formFields];
    newFormField.options = options;
    newFormField.callback = callback;
    this.formFields = [newFormField];
  }
}

export default IssueLoiService;
